import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { delay, Observable, of, Subject, takeUntil } from 'rxjs';
import { DocumentPersistenceService } from '../../../services/document-persistence.service';
import { DocumentLibraryConstants } from '../../../document-library-constants';
import { Document } from '../../../models/document';
import { DocumentAttachment } from '../../../models/document-attachment';
import { ConfirmationService, MessageService } from 'primeng/api';
import { cloneDeep } from 'lodash-es';
import { DocumentAttachmentDetails } from '../../../models/document-attachment-details';
import { DocumentService } from '../../../services/document.service';
import { DocumentTemplateDetails } from '../../../../document-template-management/models/document-template-details';
import { DocumentSourceFile } from '../../../models/documentSourceFile';
import { EqmsScopeManagementService } from '../../../../shared/services/eqms-scope-management.service';
import { DocumentSourceFileDTO } from '../../../../document/models/documentSourceFileDTO';
import { PhaseValueConstants } from '../../../../shared/constants/phaseValues-constants';
import { AssignmentGroupSharedDataService } from '../../../../shared/services/assignment-group-shared-data.service';
import { Attachment } from '../../../../document/models/attachment';

@Component({
  selector: 'app-document-files',
  templateUrl: './document-files.component.html',
  styleUrls: ['./document-files.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DocumentFilesComponent implements OnInit, OnDestroy {
  @Output() activateTabIndex = new EventEmitter<number>();
  @Input() isGlobalDocument ?: boolean;
  @Input() isInternalClientContactLimitedAccess: boolean = false;
  
  private destroy$ = new Subject<void>();
  private isLoadingDropDown = false;
  private isLoadingSourceFile = false;
  
  clientSignatureAttachmentTabVisible : boolean = false
  fileNamesForAddAndDeleteOperations: string[] = [];
  clientSignatureAttachmentNameForAddAndDeleteOperation : string[] = [];
  isReasonForDocumentUpdateRequired = false;
  documentNumber: string = '';
  documentVersion: number = 0;
  filesToSave: DocumentAttachment[] = [];
  document!: Document | null;
  maxFileSize = DocumentLibraryConstants.Document_File_Max_Size;
  clientSignatureAttachmentMaxFileSize = DocumentLibraryConstants.Document_ClientSignatureAttachment_Max_Size;
  fileAttachmentsHeaderText =
    DocumentLibraryConstants.Document_File_Attachments_Header_Text;
  clientSignatureAttachmentHeaderText = DocumentLibraryConstants.Document_ClientSignatureAttachment_HeaderText;
  documentSourceFileHeaderText =
    DocumentLibraryConstants.Document_Source_File_Header_Text;
  files: File[] = [];
  clientSignatureAttachmentFiles : File[]=[];
  savedFiles: string[] = [];
  savedClientSignatureAttachments : string[] = [];
  isDocumentSaveInProgress = false;
  documentSaveProgressMessage =
    DocumentLibraryConstants.Document_Save_InProgress;
  deletedAttachments: DocumentAttachmentDetails[] = [];
  deletedAttachmentsForConfirmation: DocumentAttachmentDetails[] = [];
  attachmentsMarkedForDeletion: DocumentAttachmentDetails[] = [];
  deletedClientSignatureAttachment? : Attachment;
  showDeletedFilesConfirmationModal = false;
  showDeletedClientSignatureAttachmentConfirmationModal = false;
  deleteAttachmentConfirmationMessage: string =
    DocumentLibraryConstants.Deleted_Attachments_Confirmation_Message;
    deleteClientSignatureAttachmentConfirmationMessage : string = DocumentLibraryConstants.Deleted_ClientSignatureAttachment_Confirmation_Message;
    currentTab = 0;
  activeTab = 0;
  isDocumentEditSlider = false;
  isUpload: boolean = false;
  documentTemplates: any[] = [];
  dropDownDisable: boolean = false;
  documentTemplateDetail!: DocumentTemplateDetails;
  showDeletedSourceFileUsingTemplateConfirmationModal = false;
  deleteSourceFileWithTemplateConfirmationMessage =
    DocumentLibraryConstants.Delete_SourceFile_WithTemplate_ConfimationMessage;
  maxFileLimit = DocumentLibraryConstants.Document_Template_File_Max_Limit;
  documentTemplateFileTypes =
    DocumentLibraryConstants.Document_Template_File_Types;
  disableFileUploader: boolean = false;
  uploadedFiles: File[] = [];
  showTabChangeModal: boolean = false;
  switchTabsConfirmationMessage =
    DocumentLibraryConstants.SwitchTabs_SourceFile_ConfirmationMessage;
  index: number = 0;
  templateId!: string;
  valueField: string =
    DocumentLibraryConstants.DocumentTemplate_DropDownBinding_ValueField;
  labelField: string =
    DocumentLibraryConstants.DocumentTemplate_DropDownBinding_LabelField;
  isDropDownSelected: boolean = false;
  isDocumentTemplateValid: boolean = true;
  errorMessages: string[] = [];  
  InactiveAssignmentGroupField : any;
  inactiveGroupsSelected : any;
  isReasonRequired = false;
  isInActiveAssignmentGroupDialog:boolean = false;
  documentErrorReminder: string = DocumentLibraryConstants.Document_ErrorText;
  documentSourceFile!: DocumentSourceFile;
  uploadedSourceFiles: File[] = [];
  savedSourceFiles: string[] = [];
  deletedSourceFile!: DocumentTemplateDetails;
  file: File[] = [];
  templateOptions: any[];
  template: string =
    DocumentLibraryConstants.DocumentTemplate_SelectionButton_NgModelValue_Template;
  templateValue: string =
    DocumentLibraryConstants.DocumentTemplate_SelectionButton_NgModelValue_Template;
  noTemplateValue: string =
    DocumentLibraryConstants.DocumentTemplate_SelectionButton_NgModelValue_NoTemplate;
  heading : string = DocumentLibraryConstants.ReasonHeading;
  isTemplate: boolean = true;
  isNoTemplate: boolean = false;
  version: string = '1';
  phase!: string;
  documentSourceFileId!: string;
  deleteFromFileUploader: boolean = false;
  fileName!: string;
  scopeIdsForTemplateList: string[] = [];
  fileId!: string;
  fileType!: string;
  ifNotCollaboration: boolean = false;
  trashIconDisabled: boolean = false;
  deletedSourceFiles!: File[];
  editedDocumentSourceFile!: DocumentSourceFile;
  editTemplate!: string;
  documentSourceFileDTO!: DocumentSourceFileDTO;
  fileUploaded!: boolean;
  scope!:number[] | undefined;
  documentAttachmentFileTypes : string = DocumentLibraryConstants.Document_Attachments_File_Types;
  fileTypes = '.pdf';
  clientSignatureAttachmentMaxLimit = DocumentLibraryConstants.Document_ClientSignatureAttachment_MaxLimit;
  documentAttachmentMaxLimit= DocumentLibraryConstants.Document_Attachments_Max_Limit;

  @Input() isDocumentFileCheckedOut!:boolean;
  @Output() enableOtherTabs = new EventEmitter<boolean>();

  constructor(
    private documentPersistenceService: DocumentPersistenceService,
    private confirmationService: ConfirmationService,
    private documentService: DocumentService,
    private eqmsScopeManagementService: EqmsScopeManagementService,
    private assignmentGroupSharedDataService:AssignmentGroupSharedDataService,
    private changeDetectorRef: ChangeDetectorRef,
    private messageService: MessageService
  ) {
    this.templateOptions = [
      {
        label:
          DocumentLibraryConstants.DocumentTemplate_SelectionButton_NgModelValue_Template,
        value:
          DocumentLibraryConstants.DocumentTemplate_SelectionButton_NgModelValue_Template,
      },
      {
        label:
          DocumentLibraryConstants.DocumentTemplate_SelectionButton_NgModelValue_NoTemplate,
        value:
          DocumentLibraryConstants.DocumentTemplate_SelectionButton_NgModelValue_NoTemplate,
      },
    ];
  }

  ngOnInit(): void {
    if (this.isInternalClientContactLimitedAccess) {
      this.clientSignatureAttachmentTabVisible = this.documentPersistenceService.clientSignatureAttachmentVisibile;
    }
    this.documentPersistenceService.documentSaveInProgress$
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (documentSaveStatus) => {
          this.isDocumentSaveInProgress = documentSaveStatus;
        }
      );
    this.isDocumentEditSlider =
      this.documentPersistenceService.isDocumentEditSlider;
    if (this.isDocumentEditSlider) {
        this.calculateSavedFiles();
        this.calculateSavedClientSignatureAttachment();
        this.documentSaveProgressMessage =
          DocumentLibraryConstants.Document_Update_InProgress;
    }
      this.documentPersistenceService.currentTabInSliderMenu$
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (tabIndex) => {
            if (
              tabIndex === DocumentLibraryConstants.Document_Menu_File_Tab_Index || (this.isGlobalDocument && tabIndex === DocumentLibraryConstants.Document_Menu_File_Tab_Index_GlobalDocument)
            ) {
              // To Update all the file tab changes when moving to other tab for save or update
              this.updateFileDetailsOnTabChange();
            }
          }
        );
      this.documentPersistenceService.currentTabInSliderMenuByCustomChange$
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (tabIndex) => {
            if (
              tabIndex === DocumentLibraryConstants.Document_Menu_File_Tab_Index || (this.isGlobalDocument && tabIndex === DocumentLibraryConstants.Document_Menu_File_Tab_Index_GlobalDocument)
            ) {         
              if(!this.isDropDownSelected)
                this.initializeFileTab();
              if(this.isDropDownSelected || this.isNoTemplate)
              this.enableOtherTabs.emit(true);
            }
          }
        );
      if(this.isGlobalDocument && this.isDocumentEditSlider) this.enableOtherTabs.emit(true);
    this.documentPersistenceService.closeAndResetDocumentSlider$
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (isClose) => {
          if (isClose) {
            this.resetDocumentAttachments();
          }
        }
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get isPhaseCollaboration(): boolean {
    const phase = this.documentPersistenceService.documentVersionDetails$?.value?.phase;
    return phase === PhaseValueConstants.Collaboration;
  }
  //document attachment
  uploadSucceeds = (uploadedFiles: File[]): Observable<string[]> => {
    this.files = [...this.files, ...uploadedFiles];
    uploadedFiles.forEach((file) => {
      if (!this.fileNamesForAddAndDeleteOperations.includes(file.name)) {
        this.fileNamesForAddAndDeleteOperations.push(file.name);
      }
    });
    const fileNames = uploadedFiles.map((i) => i.name);
    return of(fileNames).pipe(delay(3000));
  };

  deleteFile = (fileName: string): Observable<boolean> => {
    this.deleteAttachment(fileName);
    return of(true);
  };

    //client sigature attachment
    uploadSucceedsForClientSignatureAttachment = (uploadedFiles: File[]): Observable<string[]> => {
      this.clientSignatureAttachmentFiles = [...this.clientSignatureAttachmentFiles!, ...uploadedFiles];
      uploadedFiles.forEach((file) => {
        if (!this.clientSignatureAttachmentNameForAddAndDeleteOperation.includes(file.name)) {
          this.clientSignatureAttachmentNameForAddAndDeleteOperation.push(file.name);
        }
      });
      const fileNames = uploadedFiles.map((i) => i.name);
      return of(fileNames).pipe(delay(3000));
    };
  
    deleteFileForClientSignatureAttachment = (fileName: string): Observable<boolean> => {
      this.deleteAttachmentForClientSignature(fileName);
      return of(true);
    };


  openPreviousOrNextTab = (isNext:boolean) => {
    // For Edit Slider Operations
    if (this.isDocumentEditSlider || isNext) {
      if(!this.isGlobalDocument){
        this.validateDocumentTemplateSelection();
      }
      if(this.documentPersistenceService.documentDetails$.value?.documentVersion.phase == DocumentLibraryConstants.Document_Phase_ClientSignature 
        && this.documentPersistenceService.documentDetails$.value?.documentVersion.includesClientSignature){
          this.validateClientSignatureAttachment();
        }
      if(!this.isGlobalDocument){
      if((this.documentSourceFile==null || this.templateId==null) && 
      this.template && 
      (this.scope?.length == 0 || this.scope == undefined)){
        this.checkIfDropdownHasValues();
      }
    }
      this.documentPersistenceService.updateTabErrorIndex(
        DocumentLibraryConstants.Document_Menu_File_Tab_Index,
        this.errorMessages.length > 0
      );
      if(this.errorMessages.length==0){
        this.goToPreviousOrNextTab(isNext);
        this.documentPersistenceService.onCustomTabChange(
          isNext ? DocumentLibraryConstants.Document_Menu_RelatedDocuments_Tab_Index :
          DocumentLibraryConstants.Document_Menu_General_Tab_Index
        );
      }
    } else {
      this.goToPreviousOrNextTab(isNext);
    }
  };

  goToPreviousOrNextTab(isNext: boolean) {
    this.clientSignatureAttachmentTabVisible = this.documentPersistenceService.clientSignatureAttachmentVisibile;
    this.prepareDeletedAttachments();
    this.prepareDeletedClientSignatureAttachments();
    if(!this.isGlobalDocument){
      if(this.isDocumentEditSlider){
        this.patchValueForDocumentSourceFile();
      }
      this.prepareDocumentSourceFile();
    }
    this.documentPersistenceService.updateFileDetails(this.files);
    this.documentPersistenceService.updateClientSignatureAttachmentDetails(this.clientSignatureAttachmentFiles)
    if(!this.isGlobalDocument){
      this.activateTabIndex.emit(
      isNext ? DocumentLibraryConstants.Document_Menu_RelatedDocuments_Tab_Index :
        DocumentLibraryConstants.Document_Menu_General_Tab_Index
      );
      this.documentPersistenceService.onCustomTabChange(
        isNext ? DocumentLibraryConstants.Document_Menu_RelatedDocuments_Tab_Index :
          DocumentLibraryConstants.Document_Menu_General_Tab_Index
      );
    }
    else{
      this.activateTabIndex.emit(
        DocumentLibraryConstants.Document_Menu_RelatedDocuments_Tab_Index_GlobalDocument
        );
        this.documentPersistenceService.onCustomTabChange(
          DocumentLibraryConstants.Document_Menu_RelatedDocuments_Tab_Index_GlobalDocument 
        );
    }
  }

  // To Calculate Error Messages and hold all the file Tab Changes
  updateFileDetailsOnTabChange = () => {
    this.clientSignatureAttachmentTabVisible = this.documentPersistenceService.clientSignatureAttachmentVisibile;
    if(!this.isGlobalDocument){
      this.validateDocumentTemplateSelection();
    }
    if(this.documentPersistenceService.documentDetails$.value?.documentVersion.phase == DocumentLibraryConstants.Document_Phase_ClientSignature 
      && this.documentPersistenceService.documentDetails$.value?.documentVersion.includesClientSignature){
        this.validateClientSignatureAttachment();
      }
    this.documentPersistenceService.updateTabErrorIndex(
      DocumentLibraryConstants.Document_Menu_File_Tab_Index,
      this.errorMessages.length > 0
    );
    this.prepareDeletedAttachments();
    this.prepareDeletedClientSignatureAttachments();
    if(!this.isGlobalDocument){
      this.patchValueForDocumentSourceFile();
      this.prepareDocumentSourceFile();
    }
    this.documentPersistenceService.updateFileDetails(this.files);
    this.enableOtherTabs.emit(true);
    this.documentPersistenceService.updateClientSignatureAttachmentDetails(this.clientSignatureAttachmentFiles)
  };

  initializeFileTab = () => {
    this.clientSignatureAttachmentTabVisible = this.documentPersistenceService.clientSignatureAttachmentVisibile;
    this.loadDropDown();
    this.documentNumber =
      this.documentPersistenceService.documentDetails$.value?.number || '';
    this.version =
      this.documentPersistenceService.documentDetails$.value?.documentVersion
        .version || '';
    this.phase =
      this.documentPersistenceService.documentDetails$.value?.documentVersion.phase!;
    this.populateDetailsForDocumentSourceFile();
  };

  createOrUpdateDocument = () => {
    this.errorMessages = [];
    
    // LIMITED ACCESS: Skip source file validation
    if (!this.isInternalClientContactLimitedAccess) {
      if(!this.isGlobalDocument){
        this.validateDocumentTemplateSelection();
        this.checkIfDropdownHasValues();
      }
    }
    
    // Validate client signature for both limited and normal access
    if(this.documentPersistenceService.documentDetails$.value?.documentVersion.phase == DocumentLibraryConstants.Document_Phase_ClientSignature 
      && this.documentPersistenceService.documentDetails$.value?.documentVersion.includesClientSignature){
        this.validateClientSignatureAttachment();
      }
      
    if (this.errorMessages.length == 0) {
      // LIMITED ACCESS: Only prepare client signature attachments
      if (this.isInternalClientContactLimitedAccess) {
        this.prepareAddedClientSignatureAttachment();
        this.prepareDeletedClientSignatureAttachments();
      } else {
        // NORMAL: Prepare all attachments
        this.prepareAddedAttachments();
        this.prepareAddedClientSignatureAttachment();
      }
      
      if (this.documentPersistenceService.isDocumentEditSlider) {
        this.documentPersistenceService.updateTabErrorIndex(
          DocumentLibraryConstants.Document_Menu_File_Tab_Index,
          false
        );
        
        // LIMITED ACCESS: Only handle client signature deletions
        if (this.isInternalClientContactLimitedAccess) {
          this.prepareDeletedClientSignatureAttachments();
          if (this.deletedClientSignatureAttachment != null) {
            this.showDeletedClientSignatureAttachmentConfirmationModal = true;
          } else {
            this.addReasonToUpdateDocument();
          }
        } else {
          // NORMAL: Handle all deletions
          this.prepareDeletedAttachments();
          this.prepareDeletedClientSignatureAttachments();
          this.showConfirmationPopupForDeletedAttachments();
        }
      } else {
        // CREATE MODE
        this.documentPersistenceService.updateSaveInProgressStatus(true);
        if (!this.isInternalClientContactLimitedAccess) {
          this.prepareDocumentSourceFile();
          this.documentPersistenceService.updateFileDetails(this.files);
        }
        this.documentPersistenceService.updateClientSignatureAttachmentDetails(this.clientSignatureAttachmentFiles);
        this.documentPersistenceService.saveDocument();
      }
    } else if (this.isDocumentEditSlider) {
      this.documentPersistenceService.updateTabErrorIndex(
        DocumentLibraryConstants.Document_Menu_File_Tab_Index,
        true
      );
    }
  };

  prepareDocumentSourceFile() {
    this.documentSourceFileDTO = {
      isTemplate: this.isTemplate,
      isNoTemplate: this.isNoTemplate,
      templateId: this.templateId,
      uploadedSourceFile: this.uploadedSourceFiles[0],
      fileType: this.fileType,
      documentSourceFileId: this.documentSourceFileId,
    };
    if (this.isDocumentEditSlider && this.documentSourceFile != null) {
      this.documentSourceFileDTO.fileType = this.documentSourceFile.fileType;
    }
    this.documentPersistenceService.updateSourceFileDetails(
      this.documentSourceFileDTO
    );
  }

  prepareDataForCreateOrUpdateSourceFile() {
    if (this.isNoTemplate) {
      this.templateId = null!;
      let name = this.uploadedSourceFiles[0].name.split('.').pop()!
      this.fileType = (this.documentSourceFile !=null && name != this.documentSourceFile.name) || this.documentSourceFile?.name == null? name : this.documentSourceFile.name;
      this.fileName = this.uploadedSourceFiles[0].name;
    } else if (this.template && this.documentSourceFile != null) {
      this.fileType = this.documentSourceFile.fileType;
      this.uploadedSourceFiles = [];
    }
  }

  showConfirmationPopupForDeletedAttachments = () => {
    const uploadedFileNames = this.files.map((file) => file.name.toLowerCase());
    this.deletedAttachmentsForConfirmation = this.deletedAttachments.filter((attachment) => {
      return uploadedFileNames.indexOf(attachment.attachmentName.toLowerCase()) === -1;
    });

    if (this.deletedAttachmentsForConfirmation.length > 0) {
      this.showDeletedFilesConfirmationModal = true;
    } 
    //This Else is used to show dialog for Reason to Edit and Inactive Groups 
    else {   
      //Reset these values everytime
      this.isReasonRequired = false;
      this.inactiveGroupsSelected = undefined;
      this.isReasonForDocumentUpdateRequired = false;
      const documentDetails= this.documentPersistenceService.documentDetails$?.value?.documentVersion;
      this.inactiveGroupsSelected = this.assignmentGroupSharedDataService.findInactiveObjectsInValidatedList(documentDetails,this.documentPersistenceService.validatedUsersList,
        this.documentPersistenceService.usersList
      );
      if (this.deletedClientSignatureAttachment != null) {
        this.showDeletedClientSignatureAttachmentConfirmationModal = true;
      } else {
        this.addReasonToUpdateDocument(); // Only call here if both attachment types are empty
      }    
    }
  }; 


  showConfirmationPopupForDeletedClientSignatureAttachments(){
    this.showDeletedFilesConfirmationModal = false;
    if(this.deletedClientSignatureAttachment != null){
      this.showDeletedClientSignatureAttachmentConfirmationModal = true;
    }
    else{
      this.addReasonToUpdateDocument();
    } 
  }

  

  addReasonToUpdateDocument(){
    this.documentPersistenceService.updateIsGlobalDocument(this.isGlobalDocument);
    this.documentPersistenceService.updateIsLimitedAccessMode(this.isInternalClientContactLimitedAccess);
    this.showDeletedFilesConfirmationModal=false;
    const documentDetails= this.documentPersistenceService.documentDetails$?.value?.documentVersion;
    
    // LIMITED ACCESS: Skip assignment group validation
    if (!this.isInternalClientContactLimitedAccess) {
      this.inactiveGroupsSelected = this.assignmentGroupSharedDataService.findInactiveObjectsInValidatedList(documentDetails,this.documentPersistenceService.validatedUsersList,
        this.documentPersistenceService.usersList
      );
    }

    const phaseValues = [PhaseValueConstants.InReview, PhaseValueConstants.ReadyForApproval, PhaseValueConstants.Approved, PhaseValueConstants.Effective];
    const phaseString = this.documentPersistenceService.documentDetails$.value?.documentVersion.phase?.toString();
    (phaseString && phaseValues.includes(parseInt(phaseString)) && !this.documentPersistenceService.documentDetails$.value?.documentVersion.reasonForDocumentUpdate.length)? this.isReasonForDocumentUpdateRequired = true :  this.isReasonForDocumentUpdateRequired = false; 
   
    if(!this.isReasonForDocumentUpdateRequired  && this.inactiveGroupsSelected != undefined && this.inactiveGroupsSelected.length > 0){
      this.InactiveAssignmentGroupField = this.inactiveGroupsSelected;
      this.isInActiveAssignmentGroupDialog = true;
     }
     else if(!this.isReasonForDocumentUpdateRequired)
      this.updateDocument();   
  }

  closeReasonDailog(value : boolean){    
    this.isReasonForDocumentUpdateRequired = value
  }

  saveDocumentwithReason(value : any){
    this.documentPersistenceService.updatereasonforEditDocument(value);
    this.isReasonForDocumentUpdateRequired = false;
    if(this.inactiveGroupsSelected != undefined && this.inactiveGroupsSelected.length > 0){
      this.isInActiveAssignmentGroupDialog = true;   
      this.InactiveAssignmentGroupField = this.inactiveGroupsSelected;
     }
     else{
        this.updateDocument();
     }
   }
  
  closeConfirmationDailog(value : boolean){    
    this.isInActiveAssignmentGroupDialog = value
  }
  
  saveDocumentwithInactiveAssignmentGroup(){
    this.isInActiveAssignmentGroupDialog = false;
    this.updateDocument();
  }

  updateDocument = () => {
    this.closeConfirmationModal();
    this.closeConfirmationModalForDeletedClientSignatureAttachments();
    
    // LIMITED ACCESS: Skip source file preparation
    if(!this.isGlobalDocument && !this.isInternalClientContactLimitedAccess){
      this.prepareDocumentSourceFile();
    }
    
    this.documentPersistenceService.updateSaveInProgressStatus(true);
    
    // LIMITED ACCESS: Skip regular file updates
    if (!this.isInternalClientContactLimitedAccess) {
      this.documentPersistenceService.updateFileDetails(this.files);
    }
    
    this.documentPersistenceService.updateClientSignatureAttachmentDetails(this.clientSignatureAttachmentFiles);
    this.documentPersistenceService.updatereasonforEditDocument('');
    this.documentPersistenceService.updateDocument();
  };
  calculateSavedFiles = () => {
    this.savedFiles = [];
    this.fileNamesForAddAndDeleteOperations = [];
    
    this.documentPersistenceService.savedDocumentAttachments.forEach(
      (attachment) => {
        this.savedFiles.push(attachment.attachmentName);
        this.fileNamesForAddAndDeleteOperations.push(attachment.attachmentName);
      }
    );
  };

  calculateSavedClientSignatureAttachment = () => {
    this.savedClientSignatureAttachments = [];
    this.clientSignatureAttachmentNameForAddAndDeleteOperation = [];
    
    let savedAttachment = this.documentPersistenceService.documentVersionDetails$.value?.clientSignatureAttachment!;
    if(savedAttachment != null){
      this.savedClientSignatureAttachments.push(savedAttachment.attachmentName!);
      this.clientSignatureAttachmentNameForAddAndDeleteOperation.push(savedAttachment.attachmentName!);
      this.documentPersistenceService.updateSavedClientSignatureAttachments(savedAttachment);
    }
  };

  // To DO -- Need to check -- Not working with present control
  deleteFileConfirmationService = (fileName: string) => {
    let isFileToBeDeleted = false;
    this.confirmationService.confirm({
      message: DocumentLibraryConstants.Document_Slider_File_Delete_Text,
      header: DocumentLibraryConstants.Document_Slider_File_Delete_Header,
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        isFileToBeDeleted = true;
      },
    });
    return isFileToBeDeleted;
  };
  closeConfirmationModal = () => {
    this.showDeletedFilesConfirmationModal = false;
  };

  closeConfirmationModalForDeletedClientSignatureAttachments = () =>{
    this.showDeletedClientSignatureAttachmentConfirmationModal = false;
  }
  private deleteAttachment = (fileNameToDelete: string) => {
    const savedAttachment = this.documentPersistenceService.savedDocumentAttachments.find((attachment) => {
      return attachment.attachmentName.toLowerCase() === fileNameToDelete.toLowerCase();
    });

    if (
      this.isDocumentEditSlider &&
      savedAttachment &&
      !this.attachmentsMarkedForDeletion.some((attachment) => attachment.fileId === savedAttachment.fileId)
    ) {
      this.attachmentsMarkedForDeletion.push(savedAttachment);
    }

    this.files = this.files.filter((file) => {
      return file.name != fileNameToDelete;
    });

    this.fileNamesForAddAndDeleteOperations =
      this.fileNamesForAddAndDeleteOperations.filter((fileName) => {
        return fileName != fileNameToDelete;
      });

    this.savedFiles = this.savedFiles.filter((fileName) => {
      return fileName != fileNameToDelete;
    });
  };

  private deleteAttachmentForClientSignature = (fileNameToDelete: string) => {
    this.clientSignatureAttachmentFiles = this.clientSignatureAttachmentFiles!.filter((file) => {
      return file.name != fileNameToDelete;
    });
    this.clientSignatureAttachmentNameForAddAndDeleteOperation =
    this.clientSignatureAttachmentNameForAddAndDeleteOperation.filter((fileName) => {
      return fileName != fileNameToDelete;
    });
  };
  private prepareDeletedAttachments = () => {
    this.deletedAttachments = [];
    let savedAttachments = cloneDeep(
      this.documentPersistenceService.savedDocumentAttachments
    );
    let deletedAttachments = savedAttachments?.filter((savedAttachment) => {
      return (
        this.fileNamesForAddAndDeleteOperations.indexOf(
          savedAttachment.attachmentName
        ) == -1
      );
    });
    const combinedDeletedAttachments = [...this.attachmentsMarkedForDeletion];

    if (!!deletedAttachments && deletedAttachments.length > 0) {
      deletedAttachments.forEach((attachment) => {
        if (!combinedDeletedAttachments.some((item) => item.fileId === attachment.fileId)) {
          combinedDeletedAttachments.push(attachment);
        }
      });
    }

    this.deletedAttachments = combinedDeletedAttachments;

    this.documentPersistenceService.updateDeletedAttachments(
      combinedDeletedAttachments
    );
  };

  private prepareDeletedClientSignatureAttachments = () =>{
    let savedClientSignatureAttachment = cloneDeep(
      this.documentPersistenceService.savedClientSignatureAttachment
    );
    let deletedClientSignatureAttachment = 

        this.clientSignatureAttachmentNameForAddAndDeleteOperation.indexOf(
          savedClientSignatureAttachment?.attachmentName!
        ) == -1 ? savedClientSignatureAttachment : null

    if (!!deletedClientSignatureAttachment && deletedClientSignatureAttachment != null) {
      this.deletedClientSignatureAttachment = deletedClientSignatureAttachment
      this.documentPersistenceService.updateDeletedClientSignatureAttachments(
        deletedClientSignatureAttachment
      );
    }
  }
 prepareAddedAttachments = () => {
    this.files = this.files.filter((file) => {
      return this.savedFiles.indexOf(file.name) === -1;
    });
  };

  prepareAddedClientSignatureAttachment = () => {
    var files = this.clientSignatureAttachmentFiles.filter((file) => {
      return this.savedClientSignatureAttachments.indexOf(file.name) === -1;
    });
    if(files.length > 0){
      this.clientSignatureAttachmentFiles = [...this.clientSignatureAttachmentFiles, ...files];
    }
  };
  resetDocumentAttachments = () => {
    this.fileNamesForAddAndDeleteOperations = [];
    this.deletedAttachmentsForConfirmation = [];
    this.attachmentsMarkedForDeletion = [];
    this.clientSignatureAttachmentNameForAddAndDeleteOperation = [];
    this.documentNumber = '';
    this.documentVersion = 0;
    this.filesToSave = [];
    this.files = [];
    this.documentPersistenceService.updateDeletedAttachments([]);
  };

  // Document Source File Methods

  populateDetailsForDocumentSourceFile() {
    if (this.isDocumentEditSlider) {
      if (this.isLoadingSourceFile) {
        return;
      }
      
      this.isLoadingSourceFile = true;
      this.documentService
        .getDocumentSourceFile(this.documentNumber, this.version)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next:(docSourceFile) => {
            this.documentSourceFileId = docSourceFile.documentSourceFileId;
            this.documentSourceFile = docSourceFile;
            this.constructDocumentSourceFileForEdit(docSourceFile);
            this.isLoadingSourceFile = false;
          },
          error:(error)=>{
            if(error.status === 401){
              this.messageService.add({
                severity: DocumentLibraryConstants.Severity_Err,
                summary: `${error.error}`,
              })
            }
            this.enableOtherTabs.emit(true);
            this.isLoadingSourceFile = false;
          }
        });
    }
    else{
      this.prepareDataForCreateOrUpdateSourceFile();
    }
  }

  patchValueForDocumentSourceFile() {
    this.createEmptyEditedSourceFile();
    if (this.isTemplate) {
      this.editTemplate = 'Template';
      if (this.documentTemplateDetail != null || this.templateId != this.documentSourceFile.linkedDocumentTemplateId) {
        this.setDocumentTemplateDetails();
        this.editedDocumentSourceFile.linkedDocumentTemplateId =this.templateId;
        this.editedDocumentSourceFile.name =this.fileName;
        this.editedDocumentSourceFile.fileId =this.fileId;
      } else {
        this.editedDocumentSourceFile.linkedDocumentTemplateId =
          this.documentSourceFile.linkedDocumentTemplateId;
        this.editedDocumentSourceFile.name = this.documentSourceFile.name;
        this.editedDocumentSourceFile.fileId = this.documentSourceFile.fileId;
      }
      this.editedDocumentSourceFile.originSourceType = 0;
    } else if (this.isNoTemplate) {
      this.editTemplate = 'No Template';
      if (this.uploadedSourceFiles.length > 0) {
        this.editedDocumentSourceFile.linkedDocumentTemplateId = null!;
        this.detailsToDisplayForNoTemplate(this.uploadedSourceFiles[0]);
        this.fileUploaded = this.uploadedSourceFiles[0] ? true : false;
        this.editedDocumentSourceFile.originSourceType = 1;
      } else if (this.savedSourceFiles.length > 0) {
        this.editedDocumentSourceFile.linkedDocumentTemplateId = null!;
        this.fileName = this.documentSourceFile.name!;
        this.fileId = this.documentSourceFile.fileId;
        this.changeDetectorRef.detectChanges();
        this.fileUploaded = this.uploadedSourceFiles[0] ? true : false;
        this.editedDocumentSourceFile.originSourceType = 1;
      }
    }
  }

  constructDocumentSourceFileForEdit(documentSourceFile: DocumentSourceFile) {
    var originType = documentSourceFile.originSourceType;
    if (this.phase == PhaseValueConstants.Collaboration.toString() && !this.isDocumentFileCheckedOut) {
      if (this.editedDocumentSourceFile != null) {
        if (
          this.editedDocumentSourceFile.originSourceType == 0 &&
          this.editTemplate == 'Template'
        ) {
          this.fetchTemplateId();
        } else if (
          this.editedDocumentSourceFile.originSourceType == 1 &&
          this.editTemplate == 'No Template'
        ) {
          this.fetchUploadedSourceFile();
        }
      } else {
        if (originType == 0) {
          this.fetchTemplateId();
        } else if (originType == 1) {
          this.fetchUploadedSourceFile();
        }
      }
    } else if (this.phase != '0' || this.isDocumentFileCheckedOut) {
      if (originType == 0) {
        this.templateDetails();
        this.detailsToDisplayForTemplate(documentSourceFile);
      } else if (originType == 1) {
        this.noTemplateDetails();
        this.savedSourceFiles.push(this.documentSourceFile.name);
        this.detailsToDisplayForNoTemplate(documentSourceFile);
        this.isUpload=true;
        this.changeDetectorRef.detectChanges();
      }
      this.disableDocumentSourceFileControls();
      this.templateId= documentSourceFile.linkedDocumentTemplateId;
    }
  }

  fetchTemplateId() {
    if (
      this.templateId == null &&
      (this.editedDocumentSourceFile == undefined ||
        (this.editedDocumentSourceFile.linkedDocumentTemplateId == '' &&
          this.editedDocumentSourceFile.linkedDocumentTemplateId != null))
    ) {
      this.templateId = this.documentSourceFile.linkedDocumentTemplateId;
      this.isUpload = false;
      this.dropDownDisable = true;
      this.detailsToDisplayForTemplate(this.documentSourceFile);
      this.isDropDownSelected = true;
    } else if (this.editedDocumentSourceFile.linkedDocumentTemplateId != null) {
      this.templateId = this.editedDocumentSourceFile.linkedDocumentTemplateId;
      this.isUpload = false;
      this.dropDownDisable = true;
      this.detailsToDisplayForTemplate(this.editedDocumentSourceFile);
      this.isDropDownSelected = true;
    } else {
      this.templateId == null;
      this.isDropDownSelected = false;
      this.dropDownDisable = false;
      this.enableOtherTabs.emit(true);
    }
  }

  fetchUploadedSourceFile() {
    this.noTemplateDetails();
    if (this.savedSourceFiles.length === 0 && this.fileUploaded == undefined) {
      this.savedSourceFiles.push(this.documentSourceFile.name);
      this.detailsToDisplayForTemplate(this.documentSourceFile);
      this.isUpload = true;
      this.disableFileUploader = true;
    } else if (
      this.uploadedSourceFiles.length !== 0 &&
      this.savedSourceFiles.length !== 0
    ) {
      this.uploadedSourceFiles = this.uploadedSourceFiles;
      this.fileId = this.documentSourceFile.fileId;
      this.fileName = this.uploadedSourceFiles[0].name;
      this.isUpload = true;
      this.disableFileUploader = true;
    } else if (
      this.savedSourceFiles.length === 0 &&
      this.fileUploaded == false &&
      this.uploadedSourceFiles.length === 0
    ) {
      this.noDisplay();
      this.isUpload = false;
      this.disableFileUploader = false;
    }
  }

  disableDocumentSourceFileControls() {
    this.ifNotCollaboration = true;
    this.dropDownDisable = true;
    this.trashIconDisabled = true;
    this.isDropDownSelected = true;
    this.disableFileUploader = true;
  }

  detailsToDisplayForTemplate(documentSourceFile: DocumentSourceFile) {
    this.fileId = documentSourceFile.fileId;
    this.fileName = documentSourceFile.name;
    this.fileType = documentSourceFile.fileType;
    this.changeDetectorRef.detectChanges();
    setTimeout(() => {
      this.enableOtherTabs.emit(true);
      },1000);  }

  detailsToDisplayForNoTemplate(sourceFile: any) {
    this.fileName = sourceFile?.name!;
    this.fileId = sourceFile.fileId!=null?sourceFile.fileId :'';
    this.fileType = this.uploadedSourceFiles[0] != null? sourceFile?.name.split(".").pop() : sourceFile.fileType;
    this.changeDetectorRef.detectChanges();
    setTimeout(() => {
      this.enableOtherTabs.emit(true);
      },1000);  }

  noTemplateDetails() {
    this.isNoTemplate = true;
    this.isTemplate = false;
    this.template = this.noTemplateValue;
  }

  templateDetails() {
    this.isTemplate = true;
    this.isNoTemplate = false;
    this.template = this.templateValue;
  }

  //API call to load the dropdown data
  loadDropDown() {
    if (this.isLoadingDropDown) {
      return;
    }
    
    this.scopeIdsForTemplateList = [];
    let selectedScopedList =
      this.documentPersistenceService.documentDetails$.value?.documentVersion
        .eQMSScopes;
      this.scope = selectedScopedList;
    if (!!selectedScopedList && selectedScopedList.length > 0) {
      this.isLoadingDropDown = true;
      this.eqmsScopeManagementService
      .getEQMSScope()
        //.geteQMSScopeLookup()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (scopeList: any) => {
            this.calculateScopeIdForTemplates(
              scopeList,
              selectedScopedList || []
            );
            this.documentService
              .getDocumentTemplatesForDropDown(this.scopeIdsForTemplateList)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (serviceData) => {
                  if (
                    this.documentSourceFile != undefined &&
                    this.documentSourceFile !== null &&
                    this.documentSourceFile.linkedDocumentTemplateId != undefined &&
                    this.documentSourceFile.linkedDocumentTemplateId !== null
                  ) {
                    if (
                      !serviceData.some((sd: { documentTemplateId: string }) => {
                        return (
                          sd.documentTemplateId ==
                          this.documentSourceFile.linkedDocumentTemplateId
                        );
                      })
                    ) {
                      this.documentService
                        .getDocumentTemplate(this.templateId)
                        .pipe(takeUntil(this.destroy$))
                        .subscribe({
                          next: (documentTemplateDetail) => {
                            serviceData.push({
                              documentTemplateId:
                                this.documentSourceFile.linkedDocumentTemplateId,
                              documentTemplateName: documentTemplateDetail.name,
                            });
                            this.documentTemplates = serviceData;
                            this.isLoadingDropDown = false;
                          },
                          error: () => {
                            this.isLoadingDropDown = false;
                          }
                        });
                    } else {
                      this.documentTemplates = serviceData;
                      this.isLoadingDropDown = false;
                    }
                  } else {
                    this.documentTemplates = serviceData;
                    this.isLoadingDropDown = false;
                  }
                },
                error: () => {
                  this.isLoadingDropDown = false;
                }
              });
          },
          error: () => {
            this.isLoadingDropDown = false;
          }
        });
    } else {
      this.documentTemplates = [];
      this.clearDropDownValues();
    }
  }

  //validation for existence of dropdown value
  checkIfDropdownHasValues() {
    if (
      (this.isDocumentEditSlider &&
        this.phase == '0' &&
        this.documentTemplates.length == 0) ||
      this.documentTemplates.length === 0
    ) {
      if (
        this.uploadedSourceFiles.length === 0 &&
        this.savedSourceFiles.length === 0 &&
        this.isTemplate
      ) {
        if (
          !this.errorMessages.includes(
            DocumentLibraryConstants.DocumentTemplate_Dropdown_IsEmpty
          )
        ) {
          this.errorMessages.push(
            DocumentLibraryConstants.DocumentTemplate_Dropdown_IsEmpty
          );
        }
      }
    }
  }
  //API call to get the documentTemplate details for the template selected
  getDocumentTemplateDetails() {
    this.errorMessages = [];
    this.checkIfDropdownHasValues();
    this.documentService
      .getDocumentTemplate(this.templateId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((documentTemplateDetail) => {
        this.documentTemplateDetail = documentTemplateDetail;
        this.createEmptySourceFile(documentTemplateDetail);
        this.setDocumentTemplateDetails();
        this.isDropDownSelected = true;
        this.dropDownDisable = true;
        this.enableOtherTabs.emit(true);
      });
  }

  setDocumentTemplateDetails(){
    this.fileId = this.documentTemplateDetail.fileId;
    this.fileName = this.documentTemplateDetail.fileName;
    this.fileType = this.documentTemplateDetail.fileType;
  }

  //On click of trash icon
  openDeleteConfirmationModel() {
    if (this.templateId == null) {
      this.showDeletedSourceFileUsingTemplateConfirmationModal = false;
    } else {
      this.showDeletedSourceFileUsingTemplateConfirmationModal = true;
    }
  }

  //On close of confirmation modal to delete
  closeConfirmationModalForDeleteSourceFile() {
    this.showDeletedSourceFileUsingTemplateConfirmationModal = false;
  }

  //On click of yes in the delete com
  updateDocumentAfterDeletionOfSourceFile() {
    //necessary for trash icon deletion
    this.isUpload = false;
    this.clearUploadControlValues();
    this.disableFileUploader = false;
    this.clearDropDownValues();
    this.showDeletedSourceFileUsingTemplateConfirmationModal = false;
  }

  clearUploadControlValues() {
    this.uploadedSourceFiles = [];
    this.savedSourceFiles = [];
  }

  //upload document source file
  uploadSuccess = (files: File[]): Observable<string[]> => {
    this.errorMessages = [];
    if (
      this.savedSourceFiles.length === 0 &&
      this.uploadedSourceFiles.length === 0
    ) {
      this.uploadedSourceFiles = files;
      this.detailsToDisplayForNoTemplate(this.uploadedSourceFiles[0]);
      this.isUpload = true;
      this.savedSourceFiles.push(this.uploadedSourceFiles[0].name);
      this.disableFileUploader = true;
    } else {
      if (this.isDocumentEditSlider) {
        this.uploadedSourceFiles = [];
          this.uploadedSourceFiles = files;
        if (
          this.uploadedSourceFiles.length == this.maxFileLimit &&
          this.savedSourceFiles.length == this.maxFileLimit
        ) {
          this.disableFileUploader = true;
        }
        if (this.savedSourceFiles.includes(this.uploadedSourceFiles[0].name)) {
          this.savedSourceFiles = [];
          this.savedSourceFiles.push(files[0].name);
          this.disableFileUploader = true;
        }
      }
      this.uploadedSourceFiles = [];
      this.uploadedSourceFiles = files
      this.detailsToDisplayForNoTemplate(this.uploadedSourceFiles[0]);
      this.isUpload = true;
    }
    const fileNames = files.map((i) => i.name);
    return of(fileNames).pipe(delay(3000));
  };

  deleteSourceFile = (): Observable<boolean> => {
    if (this.isDocumentEditSlider) {
      this.clearUploadControlValues();
    }
    this.deleteFromFileUploader = true;
    if (this.uploadedSourceFiles.length === 0 && this.templateId == null) {
      this.errorMessages.push(
        DocumentLibraryConstants.DocumentTemplate_Selection_Required
      );
    }
    this.disableFileUploader = false;
    this.noDisplay();
    this.isUpload = false;
    return of(true);
  };

  noDisplay() {
    this.fileName = null!;
    this.fileId = null!;
  }

  //SWITCH TAB
  //on click of the other tab
  changeTabs(event: any) {
    this.errorMessages = [];
    if (
      (event.option.label == this.templateValue &&
        this.template == this.templateValue) ||
      (event.option.label == this.noTemplateValue &&
        this.template == this.noTemplateValue)
    ) {
      this.showTabChangeModal = true;
    } else {
      this.showTabChangeModal = false;
    }
  }

  //On click of yes in the modal, this method will be called
  switchTabs() {
    this.errorMessages = [];
    if (this.template == this.templateValue) {
      this.templateDetails();
      if (
        this.uploadedSourceFiles.length > 0 ||
        this.savedSourceFiles.length > 0
      ) {
        this.isUpload = false;
        this.clearUploadControlValues();
        this.noDisplay();
      }
    } else if (this.template == this.noTemplateValue) {
      this.noTemplateDetails();
      this.isUpload = false;
      this.disableFileUploader = false;
      if (this.templateId != null) {
        this.clearDropDownValues();
        this.noDisplay();
      }
    }
    this.showTabChangeModal = false;
  }

  //On click of no in the modal, this method will be called
  tabs() {
    if (this.template == this.templateValue) {
      this.template = this.noTemplateValue;
    } else if (this.template == this.noTemplateValue) {
      this.template = this.templateValue;
    }
    this.showTabChangeModal = false;
  }

  //reset dropdown value
  clearDropDownValues() {
    this.documentSourceFile = {
      documentNumber: this.documentNumber,
      documentVersion: this.documentVersion,
      originSourceType:
        DocumentLibraryConstants.DocumentSourceFile_OriginType_Template,
      linkedDocumentFilePath: null!,
      linkedDocumentFileName: null!,
      linkedDocumentFileId: null!,
      linkedDocumentFileType: null!,
      linkedDocumentTemplateId: null!,
      fileType: '',
      name: null!,
      path: ''!,
      fileId: 'a70270ad-324d-4787-82aa-9770e754abeb',
    };
    this.detailsToDisplayForTemplate(this.documentSourceFile);
    this.templateId = null!;
    this.isDropDownSelected = false;
    this.dropDownDisable = false;
  }

  //validation for not choosing a dropdown value
  private validateDocumentTemplateSelection = (): void => {
      this.selectionRequiredErrorMessage();
    // Let check here tab error can update 
  };

  validateClientSignatureAttachment(){
    if(this.clientSignatureAttachmentFiles.length === 0 && this.savedClientSignatureAttachments.length === 0){
      this.errorMessages.push(
        DocumentLibraryConstants.Document_ClientSignatureAttachment_Required
      );
    }
  }

  selectionRequiredErrorMessage() {
    this.errorMessages = [];
    this.isDocumentTemplateValid = true;
    if(!this.isDocumentEditSlider || this.phase == PhaseValueConstants.Collaboration.toString()){
      if (
        this.templateId == null &&
        this.savedSourceFiles.length == 0 &&
        this.uploadedSourceFiles.length == 0
      ) {
        this.errorMessages.push(
          DocumentLibraryConstants.DocumentTemplate_Selection_Required
        );
      }
    }
    else if (this.documentSourceFile == null){
      this.errorMessages.push(
        DocumentLibraryConstants.DocumentTemplate_Selection_Required
      );
    }

  }

  downloadSourceFile = (fileId: string, fileName: string) => {
    this.documentService.downloadFile(fileId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(      
        {
        next:(response) => {
        const fileUrl = response.fileUri;
        let downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);
        downloadLink.setAttribute('style', 'display: none');
        downloadLink.href = fileUrl;
        downloadLink.download = fileName;
        downloadLink.target = '_blank';
        downloadLink.click();
        downloadLink.remove();
      },
      error:()=>{
        if(fileId != undefined || fileId != null){
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: DocumentLibraryConstants.Document_File_UnableToDownload,
            sticky: true
          })
        }
        else{
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: DocumentLibraryConstants.Document_File_NotAvailableToDownload,
            sticky: true
          })
        }
    }
    });
  };

  private calculateScopeIdForTemplates = (
    scopeTreeList: any,
    selectedScopeList: number[]
  ): void => {
    this.scopeIdsForTemplateList = [];
    let selectedScopeIds: string[] = [];
    let scopeList = this.documentPersistenceService.scopeList;
    if (!!selectedScopeList && selectedScopeList.length > 0) {
      scopeList.forEach((scopeItem) => {
        if (selectedScopeList.filter(selectedeQMS=>{
          return selectedeQMS===Number(scopeItem.id);
        }).length >= 1) {
          selectedScopeIds.push(scopeItem.id);
        }
      });
    }
    selectedScopeIds.forEach((scopeId) => {
      //loop through the selected scope list and add those along with their parents to scopeIdsForTemplateList
      let scopeNode: any | undefined = scopeList.find(
        (scope) => scope.id === scopeId
      );
      while (!!scopeNode && scopeNode.parentId.length > 0) {
        if (this.scopeIdsForTemplateList.indexOf(scopeNode.id) === -1) {
          this.scopeIdsForTemplateList.push(scopeNode.id);
        }
        scopeNode = scopeList.find((scope) => scope.id === scopeNode?.parentId);
      }
      if (
        !!scopeNode &&
        this.scopeIdsForTemplateList.indexOf(scopeNode.id) === -1
      ) {
        this.scopeIdsForTemplateList.push(scopeNode.id);
      }
    });
  };

   private createEmptySourceFile(
     documentTemplateDetail: DocumentTemplateDetails
  ) {
    this.documentSourceFile = {
      documentNumber: this.documentNumber,
      documentVersion: this.documentVersion,
      originSourceType:
        DocumentLibraryConstants.DocumentSourceFile_OriginType_Template,
      linkedDocumentFilePath: '',
      linkedDocumentFileName: '',
      linkedDocumentFileId: ''!,
      linkedDocumentFileType: '',
      linkedDocumentTemplateId: this.templateId!,
      fileType: documentTemplateDetail.fileType,
      name: documentTemplateDetail.fileName,
      path: '',
      fileId: ''!,
    };
  }

  private createEmptyEditedSourceFile(){
    this.editedDocumentSourceFile={
        linkedDocumentFileId: ''!,
        linkedDocumentFilePath: null!,
        linkedDocumentFileName: null!,
        linkedDocumentFileType: null!,
        linkedDocumentTemplateId: ''!,
        name: ''!,
        fileId: ''!,
        fileType: null!,
        documentNumber: this.documentNumber,
        documentVersion: this.documentVersion,
        originSourceType: null!,
        path: null!,
      };
    }
}
